import React, { useState, useRef } from 'react';
import { FormControl, TextField, Typography } from '@material-ui/core';
import { isCalFamily, hideDateRangeInput } from './FilterCondition';
import moment from 'moment';
import { DateRangeContext } from '../Preview.context';
import ShowCalendar from '../../Calendar/ShowCalendar';
import { useSelector } from 'react-redux';
import FilterFormStyle from './FilterForm.style';
import classNames from 'classnames';
import {
	STR_DEMAND_VIEW_LIST,
	DT_DIM_EX_CUSTOM,
	STR_ORDER_VIEW_LIST,
	FCST_WM_YR_WK_NBR,
	WALMART_CALENDAR,
	CUSTOM,
	ATTRIBS_LOWERCASE,
	WALMART_CALENDAR_WEEK
} from 'constants/constant';

function DateRangeInput({ item, index, cbSetDateRange }) {
	const { value, extraValue = [] } = item.filter;
	const initialState = {
		start: value[0] ? moment(value[0], 'YYYY/MM/DD') : undefined,
		end: value[1] ? moment(value[1], 'YYYY/MM/DD') : undefined,
		week1: extraValue[0] ? extraValue[0] : undefined,
		week2: extraValue[1] ? extraValue[1] : undefined
	};
	const classes = FilterFormStyle();
	const selectedView = useSelector((state) => state.templateReducer.selectedView);

	if (hideDateRangeInput(item)) {
		return null;
	}
	//initiate start and end

	const [anchorEl, setAnchorEl] = useState(null);
	const [dateRange, setDateRange] = useState(initialState);
	const [updateDateFor, setUpdateDateFor] = useState(null);
	const isWkEnabled =
		item.dbtechnicalName === 'WM_YR_WK_NBR' ||
		(item.businessName === 'Week' && !STR_ORDER_VIEW_LIST.includes(selectedView));
	let isWMCal = item.parent === WALMART_CALENDAR;

	// DSIDVL-36746: For store demand forecast > Demand forecase > Walmart year week number > Custom
	// The week should start from Sat since it is walmart calendar but since the parent is "dimension"
	// and not "Walmart Calendar", it is considered gregorian which is not correct.
	if (
		item.parent === ATTRIBS_LOWERCASE.dimensions &&
		item.technicalName === WALMART_CALENDAR_WEEK
	) {
		isWMCal = true;
	}
	const { customFormStyle, specificDtFormStyle } = classes;

	const startDateRef = useRef(null);
	const endDateRef = useRef(null);

	const closeCalendar = () => {
		setAnchorEl(null);
		cbSetDateRange(dateRange, index);
	};

	const handleSetDateRange = (selection) => {
		const { start, end, week1, week2 } = selection;
		setDateRange({ start, end, week1, week2 });
		if (dateRange.start && selection.start.isBefore(dateRange.start)) {
			startDateRef.current.focus();
			setUpdateDateFor('START');
			return;
		}
		setUpdateDateFor('END');
		endDateRef.current?.focus();
	};

	const getFormattedDate = (_d, _w = '') => {
		if (_d === undefined) {
			return '';
		}
		if (isWkEnabled) {
			return `WK ${_w} (${_d.format('MM/DD/YY')})`;
		}
		return _d.format('MM/DD/YY');
	};

	const checkSingleSelection = () => {
		if (item.technicalName === FCST_WM_YR_WK_NBR) {
			return true;
		}
		if (item.filter.condition === CUSTOM) {
			return false;
		}

		if (STR_DEMAND_VIEW_LIST.includes(selectedView)) {
			return true;
		}

		if (STR_ORDER_VIEW_LIST.includes(selectedView)) {
			if (isCalFamily(item)) {
				return true;
			}
			if (!isCalFamily(item)) {
				if (DT_DIM_EX_CUSTOM.includes(item.filter.condition)) {
					return true;
				}
			}
		}

		if (['dimensions', 'measures'].includes(item.parent) && item.dataType === 'date') {
			return true;
		}

		return false;
	};

	const singleWkSelEnable = checkSingleSelection();
	const customDtClass = classNames({
		[customFormStyle]: !singleWkSelEnable,
		[specificDtFormStyle]: singleWkSelEnable
	});

	const renderEndDateInput = () => {
		if (singleWkSelEnable) {
			return;
		}
		return (
			<>
				<Typography style={{ margin: 10 }}>until</Typography>
				<TextField
					id="end-date"
					label={`End ${isWkEnabled ? 'week' : 'date'}`}
					variant="outlined"
					value={getFormattedDate(dateRange.end, dateRange.week2)}
					onKeyDown={(event) => {
						event.preventDefault();
						endDateRef.current?.focus();
						if (event.shiftKey && event.key == 'Tab') {
							startDateRef.current.focus();
							setUpdateDateFor('START');
						}
					}}
					onMouseDown={(event) => {
						setAnchorEl(event.currentTarget);
						endDateRef.current.focus();
						setUpdateDateFor('END');
					}}
					InputProps={{ style: { fontSize: 14 } }}
					inputRef={endDateRef}
					autoComplete="off"
				/>
			</>
		);
	};

	return (
		<>
			<FormControl variant="outlined" className={customDtClass}>
				<TextField
					id="start-date"
					label={`${singleWkSelEnable ? 'Select' : 'Start'} ${isWkEnabled ? 'week' : 'date'}`}
					variant="outlined"
					value={getFormattedDate(dateRange.start, dateRange.week1)}
					onKeyDown={(event) => {
						event.preventDefault();
						endDateRef.current?.focus();
						if (event.key === 'Tab') {
							endDateRef.current?.focus();
							setUpdateDateFor('END');
						}
					}}
					onMouseDown={(event) => {
						setAnchorEl(event.currentTarget);
						startDateRef.current.focus();
						setUpdateDateFor('START');
					}}
					InputProps={{ style: { fontSize: 14 } }}
					inputRef={startDateRef}
					autoComplete="off"
				/>
				{renderEndDateInput()}
			</FormControl>
			<DateRangeContext.Provider
				value={{
					cbSetDateRange: handleSetDateRange,
					usrSelection: dateRange,
					showWk: isWkEnabled,
					showWalCal: isWMCal,
					isCalMember: isCalFamily(item),
					singleWkSelEnable: singleWkSelEnable,
					bussName: item.businessName,
					updateDateFor: updateDateFor
				}}>
				<ShowCalendar open={Boolean(anchorEl)} anchorEl={anchorEl} cbHandleClose={closeCalendar} />
			</DateRangeContext.Provider>
		</>
	);
}

export default DateRangeInput;
